import { getColour } from '@lendi-ui/commons/colours';
import KeyboardArrowLeft from '@lendi-ui/icon/KeyboardArrowLeft';
import Spinner from '@lendi-ui/spinner';
import React, { useEffect, useState } from 'react';
import { analytics, ButtonType, EventCategory } from '../../analytics';
import { useBootstrappedChatState } from '../../providers/ChatBootstrapperProvider/context';
import { useChat } from '../../twilio';
import { ChatPanels } from '../../types';
import { CloseButton } from './CloseButton';
import { Menu } from './Menu';
import { HeaderWrapper, IconWrapper, TitleWrapper, HeaderRight } from './style';
export var ChatHeader = function (_a) {
    var activePanel = _a.activePanel, onShowHistory = _a.onShowHistory, showBackArrow = _a.showBackArrow, teamRestrictedViewProps = _a.teamRestrictedViewProps, onClose = _a.onClose;
    var _b = useChat(), members = _b.members, client = _b.client;
    var closeChat = useBootstrappedChatState().closeChat;
    var _c = useState(undefined), participantCount = _c[0], setParticipantsCount = _c[1];
    useEffect(function () {
        if (client && client.connectionState === 'connected' && members) {
            // Don't count Lendi Bot as participant.
            setParticipantsCount(members.length - 1);
        }
    }, [client, members]);
    var getTitle = function (activePanel, participantCount, teamRestrictedViewProps) {
        var isLoading = participantCount === undefined;
        // this is active channel participants count retrieved from twilio live connection
        var titleText = "".concat(participantCount, " ").concat(participantCount <= 1 ? 'Participant' : 'Participants');
        // this title is specific to team view where team member is not a member of the channel
        var restrictedTeamViewTitleText = "".concat(teamRestrictedViewProps === null || teamRestrictedViewProps === void 0 ? void 0 : teamRestrictedViewProps.teamRestrictedViewParticipantsCount, " ").concat((teamRestrictedViewProps === null || teamRestrictedViewProps === void 0 ? void 0 : teamRestrictedViewProps.teamRestrictedViewParticipantsCount) <= 1 ? 'Participant' : 'Participants');
        var title;
        switch (activePanel) {
            case ChatPanels.CurrentThread:
                if (teamRestrictedViewProps === null || teamRestrictedViewProps === void 0 ? void 0 : teamRestrictedViewProps.teamRestrictedView) {
                    title = restrictedTeamViewTitleText;
                }
                else {
                    title = isLoading ? (React.createElement(React.Fragment, null,
                        React.createElement(Spinner, { variant: "dark" }),
                        " Loading...")) : (titleText);
                }
                break;
            case ChatPanels.Threads:
                title = React.createElement(React.Fragment, null, "Chat threads");
                break;
            case ChatPanels.Default:
            default:
                title = React.createElement(React.Fragment, null, "Chat");
        }
        return title;
    };
    return (React.createElement(HeaderWrapper, null,
        React.createElement("div", null,
            showBackArrow && (React.createElement(IconWrapper, { onClick: function () {
                    closeChat();
                    analytics({
                        event_name: 'Button Clicked',
                        category: EventCategory.CHAT,
                        buttonType: ButtonType.ICON,
                        text: 'BackArrow',
                    });
                } },
                React.createElement(KeyboardArrowLeft, { color: getColour('interaction', 'secondary'), height: "24px", width: "24px" }))),
            React.createElement(TitleWrapper, null, getTitle(activePanel, participantCount, teamRestrictedViewProps))),
        React.createElement(HeaderRight, null,
            onShowHistory && React.createElement(Menu, { onShowHistory: onShowHistory }),
            onClose && React.createElement(CloseButton, { onClose: onClose }))));
};
//# sourceMappingURL=index.js.map